import { Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

export const routes: Routes = [
  ...(environment.uiPreviewEnabled
    ? [
        {
          path: 'ui-preview',
          loadComponent: () =>
            import('./features/system/ui-preview/ui-preview.page').then(
              (m) => m.UiPreviewPage
            ),
        },
      ]
    : []),
  {
    path: 'card-number',
    loadComponent: () =>
      import('./features/auth/card-number/card-number.page').then(
        (m) => m.CardNumberPage
      ),
  },
  {
    path: 'mobile-number',
    loadComponent: () =>
      import('./features/auth/mobile-number/mobile-number.page').then(
        (m) => m.MobileNumberPage
      ),
  },
  {
    path: 'profile-new',
    loadComponent: () =>
      import('./features/auth/profile-new/profile-new.page').then(
        (m) => m.ProfileNewPage
      ),
  },
  {
    path: 'profile-new-success',
    loadComponent: () =>
      import('./features/auth/profile-new-success/profile-new-success.page').then(
        (m) => m.ProfileNewSuccessPage
      ),
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/member/dashboard/dashboard.page').then(
        (m) => m.DashboardPage
      ),
  },
  {
    path: 'transaction-history',
    loadComponent: () =>
      import('./features/member/transaction-history/transaction-history.page').then(
        (m) => m.TransactionHistoryPage
      ),
  },
  {
    path: 'transaction-slip/:id',
    loadComponent: () =>
      import('./features/member/transaction-slip/transaction-slip.page').then(
        (m) => m.TransactionSlipPage
      ),
  },
  {
    path: 'profile-update',
    loadComponent: () =>
      import('./features/member/profile-update/profile-update.page').then(
        (m) => m.ProfileUpdatePage
      ),
  },
  {
    path: 'virtual-card',
    loadComponent: () =>
      import('./features/member/virtual-card/virtual-card.page').then(
        (m) => m.VirtualCardPage
      ),
  },
  {
    path: 'transfer-card',
    loadComponent: () =>
      import('./features/member/transfer-card/transfer-card.page').then(
        (m) => m.TransferCardPage
      ),
  },
  {
    path: 'terms-conditions',
    loadComponent: () =>
      import('./features/member/terms-conditions/terms-conditions.page').then(
        (m) => m.TermsConditionsPage
      ),
  },
  {
    path: 'update-app',
    loadComponent: () =>
      import('./features/system/update-app/update-app.page').then(
        (m) => m.UpdateAppPage
      ),
  },
  {
    path: '',
    redirectTo: 'card-number',
    pathMatch: 'full',
  },
];
